'use client'
import React from 'react';
import './banner.css';


const BannerTitle = ({ title }) => {
    return (
        <div className="banner-title">
            <h2>{title}</h2>
        </div>
    );
};

export default BannerTitle;